export const MOUNTAIN_LISTS = {
  hyakumeizan: {
    id: 'hyakumeizan',
    name: '日本百名山',
    shortName: '百名山',
    mountains: [
      { no: 1, name: '利尻山', yomi: 'りしりざん', elevation: 1721, prefecture: '北海道' },
      { no: 2, name: '羅臼岳', yomi: 'らうすだけ', elevation: 1661, prefecture: '北海道' },
      { no: 3, name: '斜里岳', yomi: 'しゃりだけ', elevation: 1547, prefecture: '北海道' },
      { no: 4, name: '雌阿寒岳', yomi: 'めあかんだけ', elevation: 1499, prefecture: '北海道' },
      { no: 5, name: '大雪山', yomi: 'たいせつざん', elevation: 2291, prefecture: '北海道' },
      { no: 6, name: 'トムラウシ山', yomi: 'とむらうしやま', elevation: 2141, prefecture: '北海道' },
      { no: 7, name: '十勝岳', yomi: 'とかちだけ', elevation: 2077, prefecture: '北海道' },
      { no: 8, name: '幌尻岳', yomi: 'ぽろしりだけ', elevation: 2052, prefecture: '北海道' },
      { no: 9, name: '羊蹄山', yomi: 'ようていざん', elevation: 1898, prefecture: '北海道' },
      { no: 10, name: '岩木山', yomi: 'いわきさん', elevation: 1625, prefecture: '青森' },
      { no: 11, name: '八甲田山', yomi: 'はっこうださん', elevation: 1585, prefecture: '青森県' },
      { no: 12, name: '八幡平', yomi: 'はちまんたい', elevation: 1613, prefecture: '岩手・秋田' },
      { no: 13, name: '岩手山', yomi: 'いわてさん', elevation: 2038, prefecture: '岩手' },
      { no: 14, name: '早池峰山', yomi: 'はやちねさん', elevation: 1917, prefecture: '岩手' },
      { no: 15, name: '鳥海山', yomi: 'ちょうかいさん', elevation: 2236, prefecture: '秋田・山形' },
      { no: 16, name: '月山', yomi: 'がっさん', elevation: 1984, prefecture: '山形' },
      { no: 17, name: '朝日岳', yomi: 'あさひだけ', elevation: 1871, prefecture: '山形県' },
      { no: 18, name: '蔵王山', yomi: 'ざおうさん', elevation: 1841, prefecture: '宮城・山形' },
      { no: 19, name: '飯豊山', yomi: 'いいでさん', elevation: 2128, prefecture: '新潟県' },
      { no: 20, name: '吾妻山', yomi: 'あづまやま', elevation: 2035, prefecture: '山形・福島' },
      { no: 21, name: '安達太良山', yomi: 'あだたらやま', elevation: 1700, prefecture: '福島' },
      { no: 22, name: '磐梯山', yomi: 'ばんだいさん', elevation: 1816, prefecture: '福島県' },
      { no: 23, name: '会津駒ヶ岳', yomi: 'あいづこまがたけ', elevation: 2133, prefecture: '福島' },
      { no: 24, name: '那須岳', yomi: 'なすだけ', elevation: 1917, prefecture: '栃木' },
      { no: 25, name: '越後駒ヶ岳', yomi: 'えちごこまがだけ', elevation: 2003, prefecture: '新潟' },
      { no: 26, name: '平ヶ岳', yomi: 'ひらがたけ', elevation: 2141, prefecture: '群馬・新潟' },
      { no: 27, name: '巻機山', yomi: 'まきはたやま', elevation: 1967, prefecture: '群馬・新潟' },
      { no: 28, name: '燧ヶ岳', yomi: 'ひうちがだけ', elevation: 2356, prefecture: '福島' },
      { no: 29, name: '至仏山', yomi: 'しぶつさん', elevation: 2228, prefecture: '群馬' },
      { no: 30, name: '谷川岳', yomi: 'たにがわだけ', elevation: 1977, prefecture: '群馬・新潟' },
      { no: 31, name: '雨飾山', yomi: 'あまかざりやま', elevation: 1963, prefecture: '新潟・長野' },
      { no: 32, name: '苗場山', yomi: 'なえばさん', elevation: 2145, prefecture: '新潟・長野' },
      { no: 33, name: '妙高山', yomi: 'みょうこうさん', elevation: 2454, prefecture: '新潟' },
      { no: 34, name: '火打山', yomi: 'ひうちやま', elevation: 2462, prefecture: '新潟' },
      { no: 35, name: '高妻山', yomi: 'たかつまやま', elevation: 2353, prefecture: '新潟・長野' },
      { no: 36, name: '男体山', yomi: 'なんたいさん', elevation: 2486, prefecture: '栃木' },
      { no: 37, name: '日光白根山', yomi: 'にっこうしらねさん', elevation: 2578, prefecture: '栃木・群馬' },
      { no: 38, name: '皇海山', yomi: 'すかいさん', elevation: 2144, prefecture: '栃木・群馬' },
      { no: 39, name: '武尊山', yomi: 'ほたかやま', elevation: 2158, prefecture: '群馬' },
      { no: 40, name: '赤城山', yomi: 'あかぎさん', elevation: 1828, prefecture: '群馬' },
      { no: 41, name: '草津白根山', yomi: 'くさつしらねさん', elevation: 2165, prefecture: '群馬' },
      { no: 42, name: '四阿山', yomi: 'あずまやさん', elevation: 2354, prefecture: '群馬・長野' },
      { no: 43, name: '浅間山', yomi: 'あさまやま', elevation: 2568, prefecture: '群馬・長野' },
      { no: 44, name: '筑波山', yomi: 'つくばさん', elevation: 877, prefecture: '茨城' },
      { no: 45, name: '両神山', yomi: 'りょうかみさん', elevation: 1723, prefecture: '埼玉' },
      { no: 46, name: '雲取山', yomi: 'くもとりやま', elevation: 2017, prefecture: '埼玉・東京・山梨' },
      { no: 47, name: '甲武信ヶ岳', yomi: 'こぶしがたけ', elevation: 2475, prefecture: '埼玉・山梨・長野' },
      { no: 48, name: '金峰山', yomi: 'きんぷさん', elevation: 2599, prefecture: '山梨・長野' },
      { no: 49, name: '瑞牆山', yomi: 'みずかきやま', elevation: 2230, prefecture: '山梨' },
      { no: 50, name: '大菩薩嶺', yomi: 'だいぼさつれい', elevation: 2057, prefecture: '山梨' },
      { no: 51, name: '丹沢山', yomi: 'たんざわさん', elevation: 1673, prefecture: '神奈川' },
      { no: 52, name: '富士山', yomi: 'ふじさん', elevation: 3776, prefecture: '山梨・静岡' },
      { no: 53, name: '天城山', yomi: 'あまぎさん', elevation: 1406, prefecture: '静岡' },
      { no: 54, name: '白馬岳', yomi: 'しろうまだけ', elevation: 2932, prefecture: '富山・長野' },
      { no: 55, name: '五竜岳', yomi: 'ごりゅうだけ', elevation: 2814, prefecture: '富山・長野' },
      { no: 56, name: '鹿島槍ヶ岳', yomi: 'かしまやりがたけ', elevation: 2889, prefecture: '富山・長野' },
      { no: 57, name: '剱岳', yomi: 'つるぎだけ', elevation: 2999, prefecture: '富山' },
      { no: 58, name: '立山', yomi: 'たてやま', elevation: 3015, prefecture: '富山' },
      { no: 59, name: '薬師岳', yomi: 'やくしだけ', elevation: 2926, prefecture: '富山' },
      { no: 60, name: '黒部五郎岳', yomi: 'くろべごろうだけ', elevation: 2840, prefecture: '富山・岐阜' },
      { no: 61, name: '水晶岳', yomi: 'すいしょうだけ', elevation: 2986, prefecture: '富山' },
      { no: 62, name: '鷲羽岳', yomi: 'わしばだけ', elevation: 2924, prefecture: '富山・長野' },
      { no: 63, name: '槍ヶ岳', yomi: 'やりがたけ', elevation: 3180, prefecture: '長野・岐阜' },
      { no: 64, name: '穂高岳', yomi: 'ほたかだけ', elevation: 3190, prefecture: '長野・岐阜' },
      { no: 65, name: '常念岳', yomi: 'じょうねんだけ', elevation: 2857, prefecture: '長野' },
      { no: 66, name: '笠ヶ岳', yomi: 'かさがたけ', elevation: 2898, prefecture: '岐阜' },
      { no: 67, name: '焼岳', yomi: 'やけだけ', elevation: 2455, prefecture: '長野・岐阜' },
      { no: 68, name: '乗鞍岳', yomi: 'のりくらだけ', elevation: 3026, prefecture: '長野・岐阜' },
      { no: 69, name: '御嶽山', yomi: 'おんたけさん', elevation: 3067, prefecture: '長野・岐阜' },
      { no: 70, name: '美ヶ原', yomi: 'うつくしがはら', elevation: 2034, prefecture: '長野' },
      { no: 71, name: '霧ヶ峰', yomi: 'きりがみね', elevation: 1925, prefecture: '長野' },
      { no: 72, name: '蓼科山', yomi: 'たてしなやま', elevation: 2531, prefecture: '長野県' },
      { no: 73, name: '八ヶ岳', yomi: 'やつがたけ', elevation: 2899, prefecture: '山梨・長野' },
      { no: 74, name: '木曽駒ヶ岳', yomi: 'きそこまがたけ', elevation: 2956, prefecture: '長野' },
      { no: 75, name: '空木岳', yomi: 'うつぎだけ', elevation: 2864, prefecture: '長野' },
      { no: 76, name: '恵那山', yomi: 'えなさん', elevation: 2191, prefecture: '長野・岐阜' },
      { no: 77, name: '甲斐駒ヶ岳', yomi: 'かいこまがたけ', elevation: 2967, prefecture: '山梨・長野' },
      { no: 78, name: '仙丈ヶ岳', yomi: 'せんじょうがだけ', elevation: 3033, prefecture: '山梨・長野' },
      { no: 79, name: '鳳凰山', yomi: 'ほうおうさん', elevation: 2841, prefecture: '山梨県' },
      { no: 80, name: '北岳', yomi: 'きただけ', elevation: 3193, prefecture: '山梨' },
      { no: 81, name: '間ノ岳', yomi: 'あいのだけ', elevation: 3190, prefecture: '山梨・静岡' },
      { no: 82, name: '塩見岳', yomi: 'しおみだけ', elevation: 3047, prefecture: '長野・静岡' },
      { no: 83, name: '荒川岳', yomi: 'あらかわだけ', elevation: 3141, prefecture: '静岡' },
      { no: 84, name: '赤石岳', yomi: 'あかいしだけ', elevation: 3121, prefecture: '長野・静岡' },
      { no: 85, name: '聖岳', yomi: 'ひじりだけ', elevation: 3013, prefecture: '長野・静岡' },
      { no: 86, name: '光岳', yomi: 'てかりだけ', elevation: 2592, prefecture: '静岡・長野' },
      { no: 87, name: '白山', yomi: 'はくさん', elevation: 2702, prefecture: '石川・岐阜' },
      { no: 88, name: '荒島岳', yomi: 'あらしまだけ', elevation: 1523, prefecture: '福井' },
      { no: 89, name: '伊吹山', yomi: 'いぶきさん', elevation: 1377, prefecture: '岐阜・滋賀' },
      { no: 90, name: '大台ヶ原', yomi: 'おおだいがはら', elevation: 1695, prefecture: '三重・奈良' },
      { no: 91, name: '大峰山', yomi: 'おおみねさん', elevation: 1915, prefecture: '奈良' },
      { no: 92, name: '大山', yomi: 'だいせん', elevation: 1729, prefecture: '鳥取' },
      { no: 93, name: '剣山', yomi: 'つるぎざん', elevation: 1955, prefecture: '徳島' },
      { no: 94, name: '石鎚山', yomi: 'いしづちさん', elevation: 1982, prefecture: '愛媛' },
      { no: 95, name: '九重山', yomi: 'くじゅうさん', elevation: 1791, prefecture: '大分' },
      { no: 96, name: '祖母山', yomi: 'そぼさん', elevation: 1756, prefecture: '大分・宮崎' },
      { no: 97, name: '阿蘇山', yomi: 'あそさん', elevation: 1592, prefecture: '熊本' },
      { no: 98, name: '霧島山', yomi: 'きりしまやま', elevation: 1700, prefecture: '宮崎・鹿児島' },
      { no: 99, name: '開聞岳', yomi: 'かいもんだけ', elevation: 924, prefecture: '鹿児島' },
      { no: 100, name: '宮之浦岳', yomi: 'みやのうらだけ', elevation: 1936, prefecture: '鹿児島' },
    ],
  },
  shin: {
    id: 'shin',
    name: '新日本百名山',
    shortName: '新百名山',
    mountains: [
      { no: 1, name: '礼文岳', yomi: 'れぶんだけ', elevation: 490, prefecture: '北海道' },
      { no: 2, name: '利尻山', yomi: 'りしりざん', elevation: 1721, prefecture: '北海道' },
      { no: 3, name: '雌阿寒岳', yomi: 'めあかんだけ', elevation: 1499, prefecture: '北海道' },
      { no: 4, name: '大雪山', yomi: 'だいせつざん', elevation: 2290, prefecture: '北海道' },
      { no: 5, name: '藻岩山', yomi: 'もいわやま', elevation: 531, prefecture: '北海道' },
      { no: 6, name: '羊蹄山', yomi: 'ようていざん', elevation: 1898, prefecture: '北海道' },
      { no: 7, name: '恵山', yomi: 'えさん', elevation: 618, prefecture: '北海道' },
      { no: 8, name: '大尽山', yomi: 'おおづくしやま', elevation: 828, prefecture: '青森' },
      { no: 9, name: '八甲田山', yomi: 'はっこうださん', elevation: 1584, prefecture: '青森' },
      { no: 10, name: '岩木山', yomi: 'いわきさん', elevation: 1625, prefecture: '青森' },
      { no: 11, name: '白神岳', yomi: 'しらがみだけ', elevation: 1235, prefecture: '青森' },
      { no: 12, name: '七時雨山', yomi: 'ななしぐれやま', elevation: 1063, prefecture: '岩手' },
      { no: 13, name: '岩手山', yomi: 'いわてさん', elevation: 2038, prefecture: '岩手' },
      { no: 14, name: '栗駒山', yomi: 'くりこまやま', elevation: 1627, prefecture: '岩手・宮城' },
      { no: 15, name: '蔵王山', yomi: 'ざおうさん', elevation: 1841, prefecture: '宮城・山形' },
      { no: 16, name: '秋田駒ヶ岳', yomi: 'あきたこまがたけ', elevation: 1637, prefecture: '岩手・秋田' },
      { no: 17, name: '大平山', yomi: 'たいへいざん', elevation: 1170, prefecture: '秋田' },
      { no: 18, name: '鳥海山', yomi: 'ちょうかいさん', elevation: 2236, prefecture: '秋田・山形' },
      { no: 19, name: '月山', yomi: 'がっさん', elevation: 1984, prefecture: '山形' },
      { no: 20, name: '大朝日岳', yomi: 'おおあさひだけ', elevation: 1870, prefecture: '山形・新潟' },
      { no: 21, name: '西吾妻山', yomi: 'にしあずまさん', elevation: 2035, prefecture: '山形・福島' },
      { no: 22, name: '霊山', yomi: 'りょうぜん', elevation: 825, prefecture: '福島' },
      { no: 23, name: '一切経山', yomi: 'いっさいきょうさん', elevation: 1949, prefecture: '福島' },
      { no: 24, name: '安達太良山', yomi: 'あだたらやま', elevation: 1700, prefecture: '福島' },
      { no: 25, name: '磐梯山', yomi: 'ばんだいさん', elevation: 1819, prefecture: '福島' },
      { no: 26, name: '奥久慈男体山', yomi: 'おくくじなんたいさん', elevation: 654, prefecture: '茨城' },
      { no: 27, name: '筑波山', yomi: 'つくばさん', elevation: 877, prefecture: '茨城' },
      { no: 28, name: '男体山', yomi: 'なんたいさん', elevation: 2486, prefecture: '栃木' },
      { no: 29, name: '谷川岳', yomi: 'たにがわだけ', elevation: 1977, prefecture: '群馬・新潟' },
      { no: 30, name: '荒船山', yomi: 'あらふねやま', elevation: 1423, prefecture: '群馬・長野' },
      { no: 31, name: '両神山', yomi: 'りょうかみさん', elevation: 1723, prefecture: '埼玉' },
      { no: 32, name: '鳥場山', yomi: 'とりばやま', elevation: 264, prefecture: '千葉' },
      { no: 33, name: '雲取山', yomi: 'くもとりやま', elevation: 2017, prefecture: '埼玉・東京・山梨' },
      { no: 34, name: '天上山', yomi: 'てんじょうさん', elevation: 571, prefecture: '東京' },
      { no: 35, name: '蛭ヶ岳', yomi: 'ひるがたけ', elevation: 1673, prefecture: '神奈川' },
      { no: 36, name: '神山', yomi: 'かみやま', elevation: 1438, prefecture: '神奈川' },
      { no: 37, name: 'ドンデン山', yomi: 'どんでんやま', elevation: 934, prefecture: '新潟' },
      { no: 38, name: '平ヶ岳', yomi: 'ひらがたけ', elevation: 2141, prefecture: '群馬・新潟' },
      { no: 39, name: '妙高山', yomi: 'みょうこうさん', elevation: 2454, prefecture: '新潟' },
      { no: 40, name: '雨飾山', yomi: 'あまかざりやま', elevation: 1963, prefecture: '新潟・長野' },
      { no: 41, name: '朝日岳', yomi: 'あさひだけ', elevation: 2418, prefecture: '新潟・富山' },
      { no: 42, name: '剱岳', yomi: 'つるぎだけ', elevation: 2999, prefecture: '富山' },
      { no: 43, name: '立山', yomi: 'たてやま', elevation: 3015, prefecture: '富山' },
      { no: 44, name: '人形山', yomi: 'にんぎょうさん', elevation: 1726, prefecture: '富山' },
      { no: 45, name: '白山', yomi: 'はくさん', elevation: 2702, prefecture: '石川・岐阜' },
      { no: 46, name: '荒島岳', yomi: 'あらしまだけ', elevation: 1523, prefecture: '福井' },
      { no: 47, name: '金峰山', yomi: 'きんぷさん', elevation: 2599, prefecture: '山梨・長野' },
      { no: 48, name: '甲斐駒ヶ岳', yomi: 'かいこまがたけ', elevation: 2967, prefecture: '山梨・長野' },
      { no: 49, name: '鳳凰山', yomi: 'ほうおうさん', elevation: 2840, prefecture: '山梨' },
      { no: 50, name: '農鳥岳', yomi: 'のうとりだけ', elevation: 3026, prefecture: '山梨・静岡' },
      { no: 51, name: '櫛形山', yomi: 'くしがたやま', elevation: 2052, prefecture: '山梨' },
      { no: 52, name: '志賀山', yomi: 'しがやま', elevation: 2036, prefecture: '長野' },
      { no: 53, name: '四阿山', yomi: 'あずまやさん', elevation: 2354, prefecture: '群馬・長野' },
      { no: 54, name: '白馬岳', yomi: 'しろうまだけ', elevation: 2932, prefecture: '富山・長野' },
      { no: 55, name: '唐松岳', yomi: 'からまつだけ', elevation: 2696, prefecture: '富山・長野' },
      { no: 56, name: '爺ヶ岳', yomi: 'じいがたけ', elevation: 2670, prefecture: '富山・長野' },
      { no: 57, name: '燕岳', yomi: 'つばくろだけ', elevation: 2763, prefecture: '長野' },
      { no: 58, name: '槍ヶ岳', yomi: 'やりがたけ', elevation: 3180, prefecture: '長野・岐阜' },
      { no: 59, name: '霧ヶ峰', yomi: 'きりがみね', elevation: 1925, prefecture: '長野' },
      { no: 60, name: '赤岳', yomi: 'あかだけ', elevation: 2899, prefecture: '山梨・長野' },
      { no: 61, name: '仙丈ヶ岳', yomi: 'せんじょうがだけ', elevation: 3033, prefecture: '山梨・長野' },
      { no: 62, name: '木曽駒ヶ岳', yomi: 'きそこまがたけ', elevation: 2956, prefecture: '長野' },
      { no: 63, name: '御嶽山', yomi: 'おんたけさん', elevation: 3067, prefecture: '長野・岐阜' },
      { no: 64, name: '奥穂高岳', yomi: 'おくほだかだけ', elevation: 3190, prefecture: '長野・岐阜' },
      { no: 65, name: '乗鞍岳', yomi: 'のりくらだけ', elevation: 3026, prefecture: '長野・岐阜' },
      { no: 66, name: '大日ヶ岳', yomi: 'だいにちがたけ', elevation: 1709, prefecture: '岐阜' },
      { no: 67, name: '天城山', yomi: 'あまぎさん', elevation: 1406, prefecture: '静岡' },
      { no: 68, name: '沼津アルプス', yomi: 'ぬまづあるぷす', elevation: 392, prefecture: '静岡' },
      { no: 69, name: '富士山', yomi: 'ふじさん', elevation: 3776, prefecture: '山梨・静岡' },
      { no: 70, name: '塩見岳', yomi: 'しおみだけ', elevation: 3052, prefecture: '長野・静岡' },
      { no: 71, name: '赤石岳', yomi: 'あかいしだけ', elevation: 3120, prefecture: '長野・静岡' },
      { no: 72, name: '鳳来寺山', yomi: 'ほうらいじさん', elevation: 684, prefecture: '愛知' },
      { no: 73, name: '大台ヶ原山', yomi: 'おおだいがはらやま', elevation: 1695, prefecture: '三重・奈良' },
      { no: 74, name: '武奈ヶ岳', yomi: 'ぶながたけ', elevation: 1214, prefecture: '滋賀' },
      { no: 75, name: '愛宕山', yomi: 'あたごやま', elevation: 924, prefecture: '京都' },
      { no: 76, name: '岩湧山', yomi: 'いわわきさん', elevation: 897, prefecture: '大阪' },
      { no: 77, name: '六甲山', yomi: 'ろっこうさん', elevation: 931, prefecture: '兵庫' },
      { no: 78, name: '氷ノ山', yomi: 'ひょうのせん', elevation: 1510, prefecture: '兵庫・鳥取' },
      { no: 79, name: '釈迦ヶ岳', yomi: 'しゃかがたけ', elevation: 1800, prefecture: '奈良' },
      { no: 80, name: '烏帽子山', yomi: 'えぼしやま', elevation: 910, prefecture: '和歌山' },
      { no: 81, name: '大山', yomi: 'だいせん', elevation: 1729, prefecture: '鳥取' },
      { no: 82, name: '三瓶山', yomi: 'さんべさん', elevation: 1126, prefecture: '島根' },
      { no: 83, name: '蒜山', yomi: 'ひるぜん', elevation: 1202, prefecture: '鳥取・岡山' },
      { no: 84, name: '弥山', yomi: 'みせん', elevation: 535, prefecture: '広島' },
      { no: 85, name: '東鳳翩山', yomi: 'ひがしほうべんさん', elevation: 734, prefecture: '山口' },
      { no: 86, name: '剣山', yomi: 'つるぎざん', elevation: 1955, prefecture: '徳島' },
      { no: 87, name: '飯野山', yomi: 'いいのやま', elevation: 422, prefecture: '香川' },
      { no: 88, name: '石鎚山', yomi: 'いしづちさん', elevation: 1982, prefecture: '愛媛' },
      { no: 89, name: '稲叢山', yomi: 'いなむらやま', elevation: 1506, prefecture: '高知' },
      { no: 90, name: '英彦山', yomi: 'ひこさん', elevation: 1200, prefecture: '福岡・大分' },
      { no: 91, name: '黒髪山', yomi: 'くろかみやま', elevation: 516, prefecture: '佐賀' },
      { no: 92, name: '普賢岳', yomi: 'ふげんだけ', elevation: 1359, prefecture: '長崎' },
      { no: 93, name: '阿蘇山', yomi: 'あそさん', elevation: 1592, prefecture: '熊本' },
      { no: 94, name: '由布岳', yomi: 'ゆふだけ', elevation: 1583, prefecture: '大分' },
      { no: 95, name: '久住山', yomi: 'くじゅうさん', elevation: 1787, prefecture: '大分' },
      { no: 96, name: '祖母山', yomi: 'そぼさん', elevation: 1756, prefecture: '大分・宮崎' },
      { no: 97, name: '高千穂峰', yomi: 'たかちほのみね', elevation: 1574, prefecture: '宮崎' },
      { no: 98, name: '開聞岳', yomi: 'かいもんだけ', elevation: 924, prefecture: '鹿児島' },
      { no: 99, name: '永田岳', yomi: 'ながただけ', elevation: 1886, prefecture: '鹿児島' },
      { no: 100, name: '於茂登岳', yomi: 'おもとだけ', elevation: 526, prefecture: '沖縄' },
    ],
  },
  nihyaku: {
    id: 'nihyaku',
    name: '日本二百名山',
    shortName: '二百名山',
    mountains: [
      { no: 101, name: '天塩岳', yomi: 'てしおだけ', elevation: 1558, prefecture: '北海道' },
      { no: 102, name: '石狩岳', yomi: 'いしかりだけ', elevation: 1967, prefecture: '北海道' },
      { no: 103, name: 'ニペソツ山', yomi: 'にぺそつやま', elevation: 2013, prefecture: '北海道' },
      { no: 104, name: 'カムイエクウチカウシ山', yomi: 'かむいえくうちかうしやま', elevation: 1979, prefecture: '北海道' },
      { no: 105, name: 'ペテガリ岳', yomi: 'ぺてがりだけ', elevation: 1736, prefecture: '北海道' },
      { no: 106, name: '芦別岳', yomi: 'あしべつだけ', elevation: 1726, prefecture: '北海道' },
      { no: 107, name: '夕張岳', yomi: 'ゆうばりだけ', elevation: 1668, prefecture: '北海道' },
      { no: 108, name: '暑寒別岳', yomi: 'しょかんべつだけ', elevation: 1492, prefecture: '北海道' },
      { no: 109, name: '樽前山', yomi: 'たるまえさん', elevation: 1041, prefecture: '北海道' },
      { no: 110, name: '駒ヶ岳', yomi: 'こまがたけ', elevation: 1131, prefecture: '北海道' },
      { no: 111, name: '白神岳', yomi: 'しらかみだけ', elevation: 1235, prefecture: '青森' },
      { no: 112, name: '姫神山', yomi: 'ひめかみさん', elevation: 1124, prefecture: '岩手' },
      { no: 113, name: '秋田駒ヶ岳', yomi: 'あきたこまがたけ', elevation: 1637, prefecture: '岩手・秋田' },
      { no: 114, name: '森吉山', yomi: 'もりよしざん', elevation: 1454, prefecture: '秋田' },
      { no: 115, name: '和賀岳', yomi: 'わがだけ', elevation: 1439, prefecture: '岩手・秋田' },
      { no: 116, name: '焼石岳', yomi: 'やけいしだけ', elevation: 1547, prefecture: '岩手' },
      { no: 117, name: '栗駒山', yomi: 'くりこまやま', elevation: 1626, prefecture: '岩手・宮城' },
      { no: 118, name: '神室山', yomi: 'かむろさん', elevation: 1365, prefecture: '秋田・山形' },
      { no: 119, name: '以東岳', yomi: 'いとうだけ', elevation: 1772, prefecture: '山形・新潟' },
      { no: 120, name: '船形山', yomi: 'ふながたやま', elevation: 1500, prefecture: '宮城・山形' },
      { no: 121, name: '杁差岳', yomi: 'えぶりさしだけ', elevation: 1636, prefecture: '新潟' },
      { no: 122, name: '二王子岳', yomi: 'にのうじだけ', elevation: 1420, prefecture: '新潟' },
      { no: 123, name: '御神楽岳', yomi: 'みかぐらだけ', elevation: 1386, prefecture: '福島・新潟' },
      { no: 124, name: '守門岳', yomi: 'すもんだけ', elevation: 1537, prefecture: '新潟' },
      { no: 125, name: '会津朝日岳', yomi: 'あいずあさひだけ', elevation: 1624, prefecture: '福島' },
      { no: 126, name: '八海山', yomi: 'はっかいさん', elevation: 1778, prefecture: '新潟' },
      { no: 127, name: '中ノ岳', yomi: 'なかのだけ', elevation: 2085, prefecture: '新潟' },
      { no: 128, name: '荒沢岳', yomi: 'あらさわだけ', elevation: 1969, prefecture: '新潟' },
      { no: 129, name: '鳥甲山', yomi: 'とりかぶとやま', elevation: 2038, prefecture: '長野' },
      { no: 130, name: '佐武流山', yomi: 'さぶるやま', elevation: 2192, prefecture: '新潟・長野' },
      { no: 131, name: '白砂山', yomi: 'しらなすやま', elevation: 2140, prefecture: '群馬・新潟・長野' },
      { no: 132, name: '岩菅山', yomi: 'いわすげやま', elevation: 2295, prefecture: '長野' },
      { no: 133, name: '仙ノ倉山', yomi: 'せんのくらやま', elevation: 2026, prefecture: '群馬・新潟' },
      { no: 134, name: '帝釈山', yomi: 'たいしゃくさん', elevation: 2060, prefecture: '福島・栃木' },
      { no: 135, name: '女峰山', yomi: 'にょほうさん', elevation: 2483, prefecture: '栃木' },
      { no: 136, name: '浅間隠山', yomi: 'あさまかくしやま', elevation: 1757, prefecture: '群馬' },
      { no: 137, name: '榛名山', yomi: 'はるなさん', elevation: 1449, prefecture: '群馬県' },
      { no: 138, name: '妙義山', yomi: 'みょうぎさん', elevation: 1104, prefecture: '群馬' },
      { no: 139, name: '荒船山', yomi: 'あらふねやま', elevation: 1423, prefecture: '群馬・長野' },
      { no: 140, name: '御座山', yomi: 'おぐらさん', elevation: 2112, prefecture: '長野' },
      { no: 141, name: '武甲山', yomi: 'ぶこうさん', elevation: 1304, prefecture: '埼玉' },
      { no: 142, name: '白石山', yomi: 'しろいしやま', elevation: 2036, prefecture: '埼玉' },
      { no: 143, name: '茅ヶ岳', yomi: 'かやがたけ', elevation: 1704, prefecture: '山梨' },
      { no: 144, name: '乾徳山', yomi: 'けんとくさん', elevation: 2031, prefecture: '山梨' },
      { no: 145, name: '大岳山', yomi: 'おおだけさん', elevation: 1266, prefecture: '東京' },
      { no: 146, name: '三ッ峠山', yomi: 'みつとうげやま', elevation: 1785, prefecture: '山梨' },
      { no: 147, name: '御正体山', yomi: 'みしょうたいやま', elevation: 1681, prefecture: '山梨' },
      { no: 148, name: '毛無山', yomi: 'けなしやま', elevation: 1964, prefecture: '山梨・静岡' },
      { no: 149, name: '愛鷹山', yomi: 'あしたかやま', elevation: 1504, prefecture: '静岡' },
      { no: 150, name: '天狗岳', yomi: 'てんぐだけ', elevation: 2646, prefecture: '長野' },
      { no: 151, name: '雪倉岳', yomi: 'ゆきくらだけ', elevation: 2611, prefecture: '新潟・富山' },
      { no: 152, name: '針ノ木岳', yomi: 'はりのきだけ', elevation: 2821, prefecture: '富山・長野' },
      { no: 153, name: '烏帽子岳', yomi: 'えぼしだけ', elevation: 2628, prefecture: '富山・長野' },
      { no: 154, name: '赤牛岳', yomi: 'あかうしだけ', elevation: 2864, prefecture: '富山' },
      { no: 155, name: '毛勝山', yomi: 'けかちやま', elevation: 2415, prefecture: '富山' },
      { no: 156, name: '奥大日岳', yomi: 'おくだいにちだけ', elevation: 2611, prefecture: '富山' },
      { no: 157, name: '有明山', yomi: 'ありあけやま', elevation: 2268, prefecture: '長野' },
      { no: 158, name: '餓鬼岳', yomi: 'がきだけ', elevation: 2647, prefecture: '長野' },
      { no: 159, name: '燕岳', yomi: 'つばくろだけ', elevation: 2763, prefecture: '長野' },
      { no: 160, name: '大天井岳', yomi: 'おてんしょうだけ', elevation: 2922, prefecture: '長野' },
      { no: 161, name: '霞沢岳', yomi: 'かすみざわだけ', elevation: 2646, prefecture: '長野' },
      { no: 162, name: '黒姫山', yomi: 'くろひめやま', elevation: 2053, prefecture: '長野' },
      { no: 163, name: '戸隠山', yomi: 'とがくしやま', elevation: 1904, prefecture: '長野' },
      { no: 164, name: '飯縄山', yomi: 'いいづなやま', elevation: 1917, prefecture: '長野' },
      { no: 165, name: '鋸岳', yomi: 'のこぎりだけ', elevation: 2685, prefecture: '山梨・長野' },
      { no: 166, name: '農鳥岳', yomi: 'のうとりだけ', elevation: 3026, prefecture: '山梨・静岡' },
      { no: 167, name: '上河内岳', yomi: 'かみこうちだけ', elevation: 2803, prefecture: '長野・静岡' },
      { no: 168, name: '池口岳', yomi: 'いけぐちだけ', elevation: 2392, prefecture: '長野・静岡' },
      { no: 169, name: '大無間山', yomi: 'だいむげんさん', elevation: 2330, prefecture: '静岡' },
      { no: 170, name: '櫛形山', yomi: 'くしがたやま', elevation: 2052, prefecture: '山梨' },
      { no: 171, name: '笊ヶ岳', yomi: 'ざるがたけ', elevation: 2629, prefecture: '山梨・静岡' },
      { no: 172, name: '七面山', yomi: 'しちめんざん', elevation: 1989, prefecture: '山梨' },
      { no: 173, name: '経ヶ岳', yomi: 'きょうがたけ', elevation: 2296, prefecture: '長野' },
      { no: 174, name: '南駒ヶ岳', yomi: 'みなみこまがだけ', elevation: 2841, prefecture: '長野' },
      { no: 175, name: '安平路山', yomi: 'あんぺいじやま', elevation: 2363, prefecture: '長野' },
      { no: 176, name: '小秀山', yomi: 'こひでやま', elevation: 1982, prefecture: '長野・岐阜' },
      { no: 177, name: '位山', yomi: 'くらいやま', elevation: 1529, prefecture: '岐阜' },
      { no: 178, name: '金剛堂山', yomi: 'こんごうどうさん', elevation: 1650, prefecture: '富山' },
      { no: 179, name: '笈ヶ岳', yomi: 'おいずるがたけ', elevation: 1841, prefecture: '富山・石川・岐阜' },
      { no: 180, name: '大日ヶ岳', yomi: 'だいにちがたけ', elevation: 1709, prefecture: '岐阜' },
      { no: 181, name: '能郷白山', yomi: 'のうごうはくさん', elevation: 1617, prefecture: '福井・岐阜' },
      { no: 182, name: '御在所岳', yomi: 'ございしょだけ', elevation: 1212, prefecture: '三重・滋賀' },
      { no: 183, name: '金剛山', yomi: 'こんごうさん', elevation: 1125, prefecture: '大阪・奈良' },
      { no: 184, name: '釈迦ヶ岳', yomi: 'しゃかがたけ', elevation: 1800, prefecture: '奈良' },
      { no: 185, name: '伯母子岳', yomi: 'おばこだけ', elevation: 1344, prefecture: '奈良' },
      { no: 186, name: '武奈ヶ岳', yomi: 'ぶながたけ', elevation: 1214, prefecture: '滋賀' },
      { no: 187, name: '氷ノ山', yomi: 'ひょうのせん', elevation: 1510, prefecture: '兵庫・鳥取' },
      { no: 188, name: '上蒜山', yomi: 'かみひるぜん', elevation: 1202, prefecture: '鳥取・岡山' },
      { no: 189, name: '三瓶山', yomi: 'さんべさん', elevation: 1126, prefecture: '島根' },
      { no: 190, name: '三嶺', yomi: 'みうね', elevation: 1894, prefecture: '徳島・高知' },
      { no: 191, name: '東赤石山', yomi: 'ひがしあかいしやま', elevation: 1706, prefecture: '愛媛' },
      { no: 192, name: '笹ヶ峰', yomi: 'ささがみね', elevation: 1860, prefecture: '愛媛・高知' },
      { no: 193, name: '英彦山', yomi: 'ひこさん', elevation: 1199, prefecture: '福岡・大分' },
      { no: 194, name: '雲仙岳', yomi: 'うんぜんだけ', elevation: 1359, prefecture: '長崎' },
      { no: 195, name: '由布岳', yomi: 'ゆふだけ', elevation: 1583, prefecture: '大分' },
      { no: 196, name: '大崩山', yomi: 'おおくえやま', elevation: 1644, prefecture: '宮崎' },
      { no: 197, name: '市房山', yomi: 'いちふさやま', elevation: 1721, prefecture: '熊本・宮崎' },
      { no: 198, name: '尾鈴山', yomi: 'おすずやま', elevation: 1405, prefecture: '宮崎' },
      { no: 199, name: '高千穂峰', yomi: 'たかちほのみね', elevation: 1574, prefecture: '宮崎・鹿児島' },
      { no: 200, name: '桜島', yomi: 'さくらじま', elevation: 1117, prefecture: '鹿児島' },
    ],
  },
  sanbyaku: {
    id: 'sanbyaku',
    name: '日本三百名山',
    shortName: '三百名山',
    mountains: [
      { no: 201, name: 'ニセイカウシュッペ山', yomi: 'にせいかうしゅっぺさん', elevation: 1883, prefecture: '北海道' },
      { no: 202, name: 'オプタテシケ山', yomi: 'おぷたてしけやま', elevation: 2013, prefecture: '北海道' },
      { no: 203, name: '神威岳', yomi: 'かむいだけ', elevation: 1600, prefecture: '北海道' },
      { no: 204, name: '余市岳', yomi: 'よいちだけ', elevation: 1488, prefecture: '北海道' },
      { no: 205, name: 'ニセコアンヌプリ', yomi: 'にせこあんぬぷり', elevation: 1308, prefecture: '北海道' },
      { no: 206, name: '狩場山', yomi: 'かりばやま', elevation: 1520, prefecture: '北海道' },
      { no: 207, name: '大千軒岳', yomi: 'だいせんげんだけ', elevation: 1072, prefecture: '北海道' },
      { no: 208, name: '五葉山', yomi: 'ごようざん', elevation: 1351, prefecture: '岩手県' },
      { no: 209, name: '烏帽子岳', yomi: 'えぼしだけ', elevation: 1478, prefecture: '岩手・秋田' },
      { no: 210, name: '太平山', yomi: 'たいへいざん', elevation: 1170, prefecture: '秋田' },
      { no: 211, name: '摩耶山', yomi: 'まやさん', elevation: 1020, prefecture: '山形' },
      { no: 212, name: '祝瓶山', yomi: 'いわいがめやま', elevation: 1417, prefecture: '山形' },
      { no: 213, name: '泉ヶ岳', yomi: 'いずみがだけ', elevation: 1175, prefecture: '宮城' },
      { no: 214, name: '一切経山', yomi: 'いっさいきょうさん', elevation: 1949, prefecture: '福島' },
      { no: 215, name: '大滝根山', yomi: 'おおたきねやま', elevation: 1192, prefecture: '福島' },
      { no: 216, name: '粟ヶ岳', yomi: 'あわがたけ', elevation: 1293, prefecture: '新潟' },
      { no: 217, name: '浅草岳', yomi: 'あさくさだけ', elevation: 1585, prefecture: '福島・新潟' },
      { no: 218, name: '金北山', yomi: 'きんぽくさん', elevation: 1172, prefecture: '新潟' },
      { no: 219, name: '米山', yomi: 'よねやま', elevation: 993, prefecture: '新潟' },
      { no: 220, name: '八溝山', yomi: 'やみぞさん', elevation: 1022, prefecture: '福島・栃木・茨城' },
      { no: 221, name: '二岐山', yomi: 'ふたまたやま', elevation: 1544, prefecture: '福島' },
      { no: 222, name: '男鹿岳', yomi: 'おじかだけ', elevation: 1777, prefecture: '福島・栃木' },
      { no: 223, name: '荒海山', yomi: 'あらかいざん', elevation: 1581, prefecture: '福島・栃木' },
      { no: 224, name: '七ヶ岳', yomi: 'ななつがたけ', elevation: 1636, prefecture: '福島' },
      { no: 225, name: '景鶴山', yomi: 'けいづるやま', elevation: 2004, prefecture: '群馬・新潟' },
      { no: 226, name: '高原山', yomi: 'たかはらやま', elevation: 1795, prefecture: '栃木' },
      { no: 227, name: '太郎山', yomi: 'たろうさん', elevation: 2368, prefecture: '栃木' },
      { no: 228, name: '袈裟丸山', yomi: 'けさまるやま', elevation: 1961, prefecture: '栃木・群馬' },
      { no: 229, name: '朝日岳', yomi: 'あさひだけ', elevation: 1945, prefecture: '群馬・新潟' },
      { no: 230, name: '笠ヶ岳', yomi: 'かさがたけ', elevation: 2076, prefecture: '長野' },
      { no: 231, name: '横手山', yomi: 'よこてやま', elevation: 2307, prefecture: '群馬・長野' },
      { no: 232, name: '諏訪山', yomi: 'すわやま', elevation: 1549, prefecture: '群馬' },
      { no: 233, name: '国師ヶ岳', yomi: 'こくしがたけ', elevation: 2592, prefecture: '山梨・長野' },
      { no: 234, name: '三頭山', yomi: 'みとうさん', elevation: 1531, prefecture: '東京・山梨' },
      { no: 235, name: '大山', yomi: 'おおやま', elevation: 1252, prefecture: '神奈川' },
      { no: 236, name: '金時山', yomi: 'きんときやま', elevation: 1212, prefecture: '神奈川・静岡' },
      { no: 237, name: '箱根山', yomi: 'はこねやま', elevation: 1438, prefecture: '神奈川' },
      { no: 238, name: '黒岳', yomi: 'くろたけ', elevation: 1793, prefecture: '山梨' },
      { no: 239, name: '鉢伏山', yomi: 'はちぶせやま', elevation: 1929, prefecture: '長野' },
      { no: 240, name: '入笠山', yomi: 'にゅうがさやま', elevation: 1955, prefecture: '長野' },
      { no: 241, name: 'アサヨ峰', yomi: 'あさよみね', elevation: 2799, prefecture: '山梨' },
      { no: 242, name: '奥茶臼山', yomi: 'おくちゃうすやま', elevation: 2474, prefecture: '長野' },
      { no: 243, name: '茶臼岳', yomi: 'ちゃうすだけ', elevation: 2604, prefecture: '長野・静岡' },
      { no: 244, name: '黒法師岳', yomi: 'くろぼうしがたけ', elevation: 2068, prefecture: '静岡' },
      { no: 245, name: '高塚山', yomi: 'たかつかやま', elevation: 1621, prefecture: '静岡' },
      { no: 246, name: '熊伏山', yomi: 'くまぶしやま', elevation: 1654, prefecture: '長野' },
      { no: 247, name: '山伏岳', yomi: 'やんぶしだけ', elevation: 2013, prefecture: '山梨・静岡' },
      { no: 248, name: '斑尾山', yomi: 'まだらおやま', elevation: 1382, prefecture: '新潟・長野' },
      { no: 249, name: '焼山', yomi: 'やけやま', elevation: 2400, prefecture: '新潟' },
      { no: 250, name: '青海黒姫山', yomi: 'おうみくろひめやま', elevation: 1221, prefecture: '新潟' },
      { no: 251, name: '朝日岳', yomi: 'あさひだけ', elevation: 2418, prefecture: '新潟・富山' },
      { no: 252, name: '唐松岳', yomi: 'からまつだけ', elevation: 2696, prefecture: '富山・長野' },
      { no: 253, name: '爺ヶ岳', yomi: 'じいがたけ', elevation: 2670, prefecture: '富山・長野' },
      { no: 254, name: '蓮華岳', yomi: 'れんげだけ', elevation: 2799, prefecture: '富山・長野' },
      { no: 255, name: '野口五郎岳', yomi: 'のぐちごろうだけ', elevation: 2924, prefecture: '富山・長野' },
      { no: 256, name: '三俣蓮華岳', yomi: 'みつまたれんげだけ', elevation: 2841, prefecture: '富山・長野・岐阜' },
      { no: 257, name: '鍬崎山', yomi: 'くわさきやま', elevation: 2090, prefecture: '富山' },
      { no: 258, name: '鉢盛山', yomi: 'はちもりやま', elevation: 2447, prefecture: '長野' },
      { no: 259, name: '奥三界岳', yomi: 'おくさんがいだけ', elevation: 1811, prefecture: '長野・岐阜' },
      { no: 260, name: '越百山', yomi: 'こすもやま', elevation: 2614, prefecture: '長野' },
      { no: 261, name: '南木曽岳', yomi: 'なぎそだけ', elevation: 1679, prefecture: '長野' },
      { no: 262, name: '白木峰', yomi: 'しらきみね', elevation: 1596, prefecture: '富山・岐阜' },
      { no: 263, name: '人形山', yomi: 'にんぎょうざん', elevation: 1726, prefecture: '富山・岐阜' },
      { no: 264, name: '医王山', yomi: 'いおうぜん', elevation: 939, prefecture: '富山・石川' },
      { no: 265, name: '大門山', yomi: 'だいもんさん', elevation: 1572, prefecture: '富山・石川' },
      { no: 266, name: '大笠山', yomi: 'おおがさやま', elevation: 1822, prefecture: '富山・石川' },
      { no: 267, name: '三方岩岳', yomi: 'さんぽういわだけ', elevation: 1736, prefecture: '石川・岐阜' },
      { no: 268, name: '猿ヶ馬場山', yomi: 'さるがばんばやま', elevation: 1875, prefecture: '岐阜' },
      { no: 269, name: '経ヶ岳', yomi: 'きょうがたけ', elevation: 1625, prefecture: '福井' },
      { no: 270, name: '野伏ヶ岳', yomi: 'のぶせがたけ', elevation: 1674, prefecture: '福井・岐阜' },
      { no: 271, name: '鷲ヶ岳', yomi: 'わしがたけ', elevation: 1671, prefecture: '岐阜' },
      { no: 272, name: '川上岳', yomi: 'かおれだけ', elevation: 1625, prefecture: '岐阜' },
      { no: 273, name: '冠山', yomi: 'かんむりやま', elevation: 1257, prefecture: '福井・岐阜' },
      { no: 274, name: '藤原岳', yomi: 'ふじわらだけ', elevation: 1120, prefecture: '三重・滋賀' },
      { no: 275, name: '倶留尊山', yomi: 'くろそやま', elevation: 1037, prefecture: '三重・奈良' },
      { no: 276, name: '三峰山', yomi: 'みうねやま', elevation: 1235, prefecture: '三重・奈良' },
      { no: 277, name: '高見山', yomi: 'たかみやま', elevation: 1248, prefecture: '三重・奈良' },
      { no: 278, name: '竜門岳', yomi: 'りゅうもんがたけ', elevation: 904, prefecture: '奈良' },
      { no: 279, name: '護摩壇山', yomi: 'ごまだんざん', elevation: 1372, prefecture: '奈良・和歌山' },
      { no: 280, name: '大和葛城山', yomi: 'やまとかつらぎさん', elevation: 959, prefecture: '大阪・奈良' },
      { no: 281, name: '蓬莱山', yomi: 'ほうらいさん', elevation: 1174, prefecture: '滋賀' },
      { no: 282, name: '比叡山', yomi: 'ひえいざん', elevation: 848, prefecture: '滋賀・京都' },
      { no: 283, name: '愛宕山', yomi: 'あたごやま', elevation: 924, prefecture: '京都' },
      { no: 284, name: '六甲山', yomi: 'ろっこうさん', elevation: 931, prefecture: '兵庫' },
      { no: 285, name: '扇ノ山', yomi: 'おうぎのせん', elevation: 1310, prefecture: '兵庫・鳥取' },
      { no: 286, name: '那岐山', yomi: 'なぎさん', elevation: 1255, prefecture: '鳥取・岡山' },
      { no: 287, name: '道後山', yomi: 'どうごやま', elevation: 1271, prefecture: '鳥取・広島' },
      { no: 288, name: '吾妻山', yomi: 'あづまやま', elevation: 1239, prefecture: '島根・広島' },
      { no: 289, name: '伊予富士', yomi: 'いよふじ', elevation: 1756, prefecture: '愛媛・高知' },
      { no: 290, name: '瓶ヶ森', yomi: 'かめがもり', elevation: 1897, prefecture: '愛媛・高知' },
      { no: 291, name: '三本杭', yomi: 'さんぼんぐい', elevation: 1226, prefecture: '愛媛・高知' },
      { no: 292, name: '篠山', yomi: 'ささやま', elevation: 1065, prefecture: '愛媛・高知' },
      { no: 293, name: '脊振山', yomi: 'せぶりやま', elevation: 1055, prefecture: '福岡・佐賀' },
      { no: 294, name: '多良岳', yomi: 'たらだけ', elevation: 996, prefecture: '佐賀・長崎' },
      { no: 295, name: '鶴見岳', yomi: 'つるみだけ', elevation: 1375, prefecture: '大分' },
      { no: 296, name: '大船山', yomi: 'たいせんざん', elevation: 1786, prefecture: '大分' },
      { no: 297, name: '涌蓋山', yomi: 'わいたざん', elevation: 1500, prefecture: '熊本・大分' },
      { no: 298, name: '傾山', yomi: 'かたむきやま', elevation: 1605, prefecture: '大分' },
      { no: 299, name: '国見岳', yomi: 'くにみだけ', elevation: 1739, prefecture: '熊本・宮崎' },
      { no: 300, name: '高隈山', yomi: 'たかくまやま', elevation: 1236, prefecture: '鹿児島' },
      { no: 301, name: '山上ヶ岳', yomi: 'さんじょうがたけ', elevation: 1719, prefecture: '奈良' },
    ],
  },
};

export const LIST_ORDER = ['hyakumeizan', 'shin', 'nihyaku', 'sanbyaku'];

/**
 * 複数リストに登場する山の対応マップ
 * { '山名': [{ listId, no }, ...] }
 * 同一山名が複数リストにある場合のみ含まれる
 */
function buildCrossListMap() {
  const map = {};
  for (const [listId, listData] of Object.entries(MOUNTAIN_LISTS)) {
    for (const mountain of listData.mountains) {
      if (!map[mountain.name]) map[mountain.name] = [];
      map[mountain.name].push({ listId, no: mountain.no });
    }
  }
  // 2つ以上のリストに存在する山のみ残す
  return Object.fromEntries(
    Object.entries(map).filter(([, entries]) => entries.length > 1)
  );
}

export const CROSS_LIST_MAP = buildCrossListMap();
